import { Icon } from './icon';

export const UserStub = {
	name: 'ui-image-stack-steps-user-stub',
	components: { Icon },
	template: `
		<Icon icon="person" color="var(--ui-color-base-15)"/>
	`,
};
